export default {
  outList: [
    {
      light_point_1:[
        {
          title: '鲲鹏动力400T',
          type: 'image',
          video: '',
          image: 'lightPoint/1/2.jpg',
          text: '超强动力输出随叫随到，从容不迫应对各种环境'
        }
      ],
      light_point_2:[
        {
          title: 'CDC“磁悬浮”悬架 ',
          type: 'image',
          video: '',
          image: 'lightPoint/1/1.jpg',
          text: '毫秒级响应调节，20万享受豪车都要选装的舒适体验'
        },
      ],
      light_point_3:[
        {
          title: 'L2.9智能驾驶辅助',
          type: 'image',
          video: '',
          image: 'lightPoint/1/3.jpg',
          text: '高速巡航轻松不累，无惧魔鬼停车场'
        }
      ]
    }
  ],
  innerList: [
    {
      light_point_1:[
        {
          title: '24.6吋极智丝滑真曲面屏',
          type: 'image',
          video: '',
          image: 'lightPoint/2/2.jpg',
          text: '高端智慧大屏科技，无惧4D魔幻城市'
        },
      ],
      light_point_2:[
        {
          title: '0重力超感副驾',
          type: 'image',
          video: '',
          image: 'lightPoint/2/4.jpg',
          text: '沉浸式享受SPA级按摩，舒心每一程'
        }
      ],
      light_point_3:[
        {
          title: '256色光瀑式音律氛围灯',
          type: 'image',
          video: '',
          image: 'lightPoint/2/3.jpg',
          text: '视听联动，下班回家的私人影音休息室'
        }
      ],
      light_point_4:[
        {
          title: 'C-PURE奇瑞净立方绿色座舱',
          type: 'image',
          video: '',
          image: 'lightPoint/2/5.jpg',
          text: '纯净呼吸系统，随时随地保持空气清新'
        }
      ]
    }
  ],
  tab1:[
    {
      title: 'CDC“磁悬浮”悬架 ',
      type: 'image',
      video: '',
      image: 'lightPoint/1/1.jpg',
      text: '毫秒级响应调节，20万享受豪车都要选装的舒适体验'
    },
    {
      title: 'L2.9智能驾驶辅助',
      type: 'image',
      video: '',
      image: 'lightPoint/1/3.jpg',
      text: '高速巡航轻松不累，无惧魔鬼停车场'
    },
    {
      title: '鲲鹏动力400T',
      type: 'image',
      video: '',
      image: 'lightPoint/1/2.jpg',
      text: '超强动力输出随叫随到，从容不迫应对各种环境'
    },
    {
      title: '爱信8AT',
      type: 'image',
      video: '',
      image: 'lightPoint/1/4.jpg',
      text: '超强动力输出随叫随到，从容不迫应对各种环境'
    },
    {
      title: '全场景智控四驱',
      type: 'image',
      video: '',
      image: 'lightPoint/1/5.jpg',
      text: '超强动力输出随叫随到，从容不迫应对各种环境'
    }
  ],
  tab2: [
    {
      title: '540°立体超感空调系统',
      type: 'image',
      video: '',
      image: 'lightPoint/2/1.jpg',
      text: '有温感无不适风感，享受面面俱到的温感呵护'
    },
    {
      title: '24.6吋极智丝滑真曲面屏',
      type: 'image',
      video: '',
      image: 'lightPoint/2/2.jpg',
      text: '高端智慧大屏科技，无惧4D魔幻城市'
    },
    {
      title: '256色光瀑式音律氛围灯',
      type: 'image',
      video: '',
      image: 'lightPoint/2/3.jpg',
      text: '视听联动，下班回家的私人影音休息室'
    },
    {
      title: '0重力超感副驾',
      type: 'image',
      video: '',
      image: 'lightPoint/2/4.jpg',
      text: '沉浸式享受SPA级按摩，舒心每一程'
    },{
      title: 'C-PURE奇瑞净立方绿色座舱',
      type: 'image',
      video: '',
      image: 'lightPoint/2/5.jpg',
      text: '纯净呼吸系统，随时随地保持空气清新'
    },{
      title: '越级超大静谧空间',
      type: 'image',
      video: '',
      image: 'lightPoint/2/6.jpg',
      text: '即使全员出发，也能纵享自在空间'
    }
  ],
  tab3: [
    {
      title: '360°环抱式10气囊防护',
      type: 'image',
      video: '',
      image: 'lightPoint/3/1.jpg',
      text: '不同角度的碰撞保护，为家人提供坚固的安全堡垒'
    }
  ],
  tab4: [
    {
      title: '',
      type: 'video',
      video: 'lightPoint/4/ruihu9.mp4',
      image: 'lightPoint/4/4.jpg',
      text: ''
    }
  ]
}
